import React from "react";

const EftPos = ({fill}) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      d="M13.0202 6.008C11.0513 6.95743 10.0717 8.64238 9.63925 10.132C9.23365 11.5293 9.43232 13.0364 10.0046 14.374C12.2611 19.6481 17.5977 19.098 21.0569 17.7237C21.4478 17.5684 21.8179 17.9845 21.5612 18.3177C19.9953 20.3495 16.9981 23 13.1301 23C7.25012 23 2.63013 17.96 2.63013 12.29C2.63013 8.63578 4.26564 6.28084 5.56027 5.13739C6.08234 4.67629 6.76302 4.45466 7.45659 4.39039C10.4615 4.11192 12.2808 4.78753 13.1261 5.3941C13.3575 5.5601 13.2767 5.88433 13.0202 6.008Z"
      fill={fill}
    />
    <path
      d="M15.86 9.34999C15.86 4.36053 11.2108 3.53263 8.18872 3.77411C7.96473 3.792 7.85923 3.50188 8.05654 3.39434C10.0773 2.2929 12.3541 2 13.34 2C16.7515 2 18.9275 3.51815 20.2428 5.30463C22.0628 7.77659 22.0736 11.466 19.9378 13.6708C17.6998 15.9811 14.3598 15.7701 12.1683 15.0718C11.9648 15.0069 11.995 14.7096 12.2002 14.6505C15.1054 13.8136 15.86 10.8392 15.86 9.34999Z"
      fill={fill}
    />
  </svg>
);

export default EftPos;
